import React, { useState, useEffect } from "react";

const CustomCheckbox = (props) => {
    const [isChecked, setChecked] = useState(props.value || false);

    useEffect(() => {
        let colId = props.column.colId;
        props.node.setDataValue(colId, isChecked);
    }, [isChecked, props.column.colId, props.node]);

    const checkedHandler = (event) => {
        setChecked(event.target.checked);
    };

    return (
        <input
            disabled={!props.colDef.editable}
            type="checkbox"
            onClick={checkedHandler}
            checked={isChecked}
        />
    );
};

export default CustomCheckbox;
